<template>
  <el-select
    v-model="selectedRoleId"
    @change="handleChange"
    placeholder="请选择角色"
    filterable
    remote
    :remote-method="searchRoles"
    :loading="loading"
    :disabled="disabled"
    :multiple="isMultiple"
  >
  <el-option
    v-for="item in filteredRoles"
    :key="item.id"
    :value="item.id"
    :label="item.name"
  />
  </el-select>
</template>

<script>
import { basementAjaxGet } from "../common/ajax";

export default {
  props: {
    value: {
      type: [Number,Array],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: { // 新增 type prop
      type: String,
      default: 'single' // 默认单选
    }
  },
  data() {
    return {
      loading: false,
      filteredRoles: [],
      selectedRoleId: this.value // 初始化为传入的值
    };
  },
  computed: {
    isMultiple() {
      return this.type === 'multiple'; // 判断是否为多选
    }
  },
  watch: {
    value(newValue) {
      this.selectedRoleId = newValue; // 监听外部 value 变化
    }
  },
  mounted() {
    this.searchRoles("");
  },
  methods: {
    handleChange(value) {
      this.$emit('input', value); // 返回数组或单个值
    },
    searchRoles(query) {
      this.loading = true; // 显示加载状态
      this.getAllRole(query)
        .then(res => {
          this.filteredRoles = res.data.data; // 更新角色列表
          this.loading = false; // 隐藏加载状态
        })
        .catch(err => {
          this.loading = false; // 隐藏加载状态
          this.$message({
            type: "error",
            message: err.data.message || '请求失败'
          });
        });
    },
    getAllRole(name) {
      const that = this;
      return new Promise((resolve, reject) => {
        basementAjaxGet(
          that,
          `/techik/role/list?name=${name}`,
          res => {
            resolve(res);
          },
          res => {
            reject(res);
          }
        );
      });
    }
  }
};
</script>

<style scoped>
/* 样式可根据需求进行调整 */
</style>



// WEBPACK FOOTER //
// src/components/RoleSelcet.vue